import Logo from "../../static/newLogo.png";
import schoollogo from "../../static/Home/logo.svg";
import {
  Box,
  Grid,
  Divider,
  Container,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import { Link, useNavigate } from "react-router-dom";

function MainFooter() {
  const navigate = useNavigate();
  return (
    <Box
      style={{
        color: "#F39300",
        backgroundColor: "#FAFAFA",
        bottom: 0,
        left: 0,
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box>
        <Grid container>
          <Grid item sm={12} md={4} lg={4} sx={{ marginTop: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                marginLeft: 10,
              }}
            >
              <Link to="/">
                <img src={Logo} alt="Logo" style={{ height: 75, width: 75 }} />
              </Link>

              <img src={schoollogo} alt="schoolmidas" style={{ width: 200 }} />
              <Typography
                variant="h6"
                sx={{
                  marginBottom: 2,
                  color: "#4D4D4D",
                  fontFamily: "Barlow, sans-serif",
                }}
              >
                Best School Management System
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            sm={12}
            md={8}
            lg={8}
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "space-around" }}>
              {" "}
              <Box sx={{ margin: 5 }}>
                {" "}
                <Button
                  sx={{
                    textTransform: "unset",
                    color: "#F39300",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Barlow, sans-serif",
                  }}
                >
                  Welcome to SCHOOL MIDAS
                </Button>
              </Box>
              <Box sx={{ margin: 5 }}>
                {" "}
                <Button
                  sx={{
                    textTransform: "unset",
                    color: "#F39300",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Barlow, sans-serif",
                  }}
                >
                  How will SCHOOL MIDAS make Work Easier?
                </Button>
              </Box>
              <Box sx={{ margin: 5 }}>
                <Button
                  sx={{
                    textTransform: "unset",
                    color: "#F39300",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Barlow, sans-serif",
                  }}
                >
                  Why Schools Trust Us?{" "}
                </Button>
              </Box>
              <Box sx={{ margin: 5 }}>
                <Button
                  sx={{
                    textTransform: "unset",
                    color: "#F39300",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Barlow, sans-serif",
                  }}
                >
                  Mobile Apps
                </Button>
              </Box>
              <Box sx={{ margin: 5 }}>
                <Button
                  sx={{
                    textTransform: "unset",
                    color: "#F39300",
                    fontSize: "14px",
                    fontWeight: "bold",
                    fontFamily: "Barlow, sans-serif",
                  }}
                >
                  Contact Us
                </Button>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                marginLeft: "auto",
                marginRight: 10,
                marginBottom: 2,
              }}
            >
              <IconButton sx={{ color: "#0752B5" }}>
                <LinkedInIcon />
              </IconButton>
              <IconButton sx={{ color: "#0752B5" }}>
                <FacebookIcon />
              </IconButton>
              <IconButton sx={{ color: "#0752B5" }}>
                <InstagramIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ backgroundColor: "#FAFAFA" }} />
      <Box
        sx={{
          padding: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Container
          maxWidth="lg"
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#989898",
              fontFamily: "Barlow, sans-serif",
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            @Copyright 2024, All Rights Reserved{" "}
          </Typography>
          <Typography variant="body2">
            <Link
              style={{
                textDecoration: "none",
                color: "#989898",
                fontFamily: "Barlow, sans-serif",
                fontSize: 16,
                fontWeight: 500,
              }}
            >
              Terms & Conditions | Privacy Policy
            </Link>
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

export default MainFooter;
